<script lang="ts" module>
	const badgeClass = "flex-none text-xs rounded outline-dashed outline-1 hover:brightness-[.95] font-medium font-mono inline-flex items-center justify-center px-2.5 py-0.5 mr-0.5 gap-1";
	const badgeBorderClasses = {
		base: "outline-gray-500",
		green: "outline-green-500",
		red: "outline-red-500",
	};
	const badgeHoverClasses = {
		base: "hover:bg-gray-200",
		red: "hover:bg-red-200",
		green: "hover:bg-green-200",
	};
	const colorClasses = {
		base: "bg-gray-50 text-gray-900",
		green: "bg-green-50 text-green-900 placeholder-green-700",
		red: "bg-red-50 text-red-900 placeholder-red-700",
	};
</script>

<script lang="ts">
	import { twMerge } from "tailwind-merge";
	import Icon from "#lib/components/Icon.svelte";
	import { providerIcons } from "#lib/iconProvider.js";
	import { Provider } from "#lib/tokenProvider.js";

	interface Props {
		provider?: Provider;
		label: string;
		hideIcon?: boolean;
		class?: string;
		style?: string;
	}

	const { provider = Provider.INVALID, label, hideIcon, class: className, style }: Props = $props();
	const icon = $derived(providerIcons.get(provider));
	const color = $derived(provider === "invalid" ? "red" : "base");
</script>

<span class={twMerge("h-6 overflow-y-visible align-middle", badgeClass, badgeBorderClasses[color], badgeHoverClasses[color], colorClasses[color], className)} {style}>
	{#if icon && !hideIcon}
		<Icon class="h-4 w-4 flex-none" name={icon.icon} iconSet={icon.iconSet} />
	{/if}
	{label}
</span>
